import { useContext } from 'react';
import { ContractPoolContext } from '@/contexts/contract-pool-context';

export const useContractPool = () => {
  const context = useContext(ContractPoolContext);
  if (!context) {
    throw new Error('useContractPool must be used within a ContractPoolContext');
  }

  return context;
};
